var $slider1 = $('.image-slider-2');
if ($slider1.length) {

  var currentSlide;
  var slidesCount;
  var sliderCounter = document.createElement('div');
  sliderCounter.classList.add('slider__counter');

  var updateSliderCounter = function(slick, currentIndex) {
    currentSlide = slick.slickCurrentSlide() + 1;
    slidesCount = slick.slideCount;
    $(sliderCounter).text(currentSlide + '/' +slidesCount)
  };

  $slider1.on('init', function(event, slick) {
    $slider1.append(sliderCounter);
    updateSliderCounter(slick);
  });

  $slider1.on('afterChange', function(event, slick, currentSlide) {
    updateSliderCounter(slick, currentSlide);
  });

  $slider1.slick({
  asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: false,
  nextArrow: false,
  fade: true,
  adaptiveHeight: false,
  asNavFor: $slider1
});
}
// custom code start
var $status = $('.sliderpagingInfo');
var $slickElement = $('.customslideshow');

$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  var i = (currentSlide ? currentSlide : 0) + 1;
  $status.text(i + '/' + slick.slideCount);
});

$slickElement.slick({
  autoplay: false,
  dots: false,
  arrows: true,
  asNavFor: '.slider-nav-1'
});
  $('.slider-nav-1').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: false,
  nextArrow: false,
  fade: true,
  adaptiveHeight: false,
  asNavFor: $slickElement
});

// closed

// Press Slider
mobileOnlySlider(".press-slider", false, false, 2, 1, true, 0, 3000, "false", 1024);

function mobileOnlySlider($slidername, $dots, $arrows, $slidesToShow, $slidesToScroll, $autoplay, $autoplaySpeed, $speed, $pauseOnHover, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: $arrows,
    autoplay: $autoplay,
    slidesToShow: $slidesToShow,
    slidesToScroll: $slidesToScroll,
    autoplaySpeed: $autoplaySpeed,
    speed: $speed,
    pauseOnHover: $pauseOnHover,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick"
      }
    ]
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}

// Press Slider

// Doctor on mobile Slider
// mobileOnlySlider(".slider-marquee", false, false, 1, 1, true, 0, 3000, "false", 1024);

// function mobileOnlySlider($slidername, $dots, $arrows, $slidesToShow, $slidesToScroll, $autoplay, $autoplaySpeed, $speed, $pauseOnHover, $breakpoint) {
//   var slider = $($slidername);
//   var settings = {
//     mobileFirst: true,
//     dots: $dots,
//     arrows: $arrows,
//     autoplay: $autoplay,
//     slidesToShow: $slidesToShow,
//     slidesToScroll: $slidesToScroll,
//     autoplaySpeed: $autoplaySpeed,
//     speed: $speed,
//     pauseOnHover: $pauseOnHover,
//     cssEase: 'linear',
//     responsive: [
//       {
//         breakpoint: $breakpoint,
//         settings: "unslick"
//       }
//     ]
//   };

//   slider.slick(settings);

//   $(window).on("resize", function () {
//     if ($(window).width() > $breakpoint) {
//       return;
//     }
//     if (!slider.hasClass("slick-initialized")) {
//       return slider.slick(settings);
//     }
//   });
// }

// Doctor on mobile Slider

// Text Slider
$('#testimonials-text-slider').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});
// Text Slider


$('.responsive').slick({
  // dots: true,
  arrows: true,
  speed: 500,
  autoplaySpeed: 5000,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false
});

$('.slider-init').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 500,
  autoplaySpeed: 5000,
  autoplay: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
function UpsellSliderInit() {
// PDP Page Upsell Slider
$('.Upsell-slider-init').slick({
  dots: true,
  infinite: false,
  arrows: false,
  speed: 500,
  autoplaySpeed: 5000,
  autoplay: false,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});
}
UpsellSliderInit();
$('.ambassador-image-carousel').slick({
  dots: true,
  infinite: true,
  arrows: false,
  speed: 500,
  autoplaySpeed: 5000,
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false,
});

// Ambassador Image Carousel

$('.single-slider-init').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 500,
  autoplaySpeed: 5000,
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// Index Testimonials Slider

$slick_slider = $('.testimonials-index-slider');
settings_slider = {
  arrows: true,
  speed: 500,
  autoplaySpeed: 5000,
  autoplay: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}
slick_on_mobile($slick_slider, settings_slider);

// slick on mobile
function slick_on_mobile(slider, settings) {
  $(window).on('load resize', function () {
    if ($(window).width() < 767) {
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }
      return
    }
    if (!slider.hasClass('slick-initialized')) {
      return slider.slick(settings);
    }
  });
};
// Index Testimonials

// $('.product-page-slider').slick({
//   arrows: true,
//   infinite: false,
//   slidesToShow: 1,
//   slidesToScroll: 1,
// });


  // Main slider initialization
 $('.product-page-slider').slick({
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.pdp-thumbnail-slider',
    focusOnSelect: true,
    adaptiveHeight: true
  });

  // Thumbnail slider initialization
  $('.pdp-thumbnail-slider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: '.product-page-slider',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  });

  // Sync thumbnails with main slider
  $('.pdp-thumbnail-slider').on('click', '.thumbnail-img', function() {
    var slideIndex = $(this).data('slide-index');
    $('.product-page-slider').slick('slickGoTo', slideIndex);
  });

  // Highlight active thumbnail
  $('.product-page-slider').on('afterChange', function(event, slick, currentSlide) {
    $('.thumbnail-img').removeClass('active');
    $('.thumbnail-img[data-slide-index="' + currentSlide + '"]').addClass('active');
  });

  // Initial active thumbnail
  $('.thumbnail-img').first().addClass('active');




setTimeout(function(){

  $(".regular").slick({
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4
  });
}, 3000);


  var state = {
    disabledDates: {
   //   days: [1,2,3,5,6, 0], // show only thursday days
      to: new Date(Date.now() - 8640000) //Disable Prevoius Date
    }
  }


  ////////////// onchnage select box chnage value code /////////////////

  setTimeout(function(){
    $("#paragraphSpaceOPtion").on("change",function(){
      var val=$(this).find('option:selected').val();
//       console.log(val);
      var strg = val.replace(/ +/g, "");
      $('#'+ strg).show().siblings().hide();

    });

  }, 3000);



  //////////// enable specific dates//////////////////
  var enabledDays = ["2021-10-12","2021-11-10","2021-11-24"];
  var test = {
    allowedDates: val => enabledDays.indexOf(val) !== -1
  };
  //////////// disable Day //////////////////
  var states = {
    disabledDates: {
     days: [2,3,5,6, 0], // Disable days
     to: new Date(Date.now() - 8640000), //Disable Prevoius Date
     dates: [
            new Date("10/11/2021"),
            new Date("11/11/2021"),
            new Date("11/25/2021"),
       		new Date("01/17/2022"),
       		new Date("02/21/2022"),
        ],
//        enableDays: ['10/12/2021','11/10/2021','11/24/2021'],
    }
// monthBeforeYear: true,
  };

  /////////// Length Count Jquery///////////////////
  var maxLength = 240;
  $('textarea').keyup(function() {
    var length = $(this).val().length;
    var length = maxLength-length;
    $('.textarea-text').text(length);
  });


  /**
  * Check uncheck conditinal code for nonbreastfeeding
  **/
  function checkThisProduct(e) {
    var wrapperId = $(e).closest(".dynamicProductsWrapper").attr("id")
    console.log('dynamicProductsWrapper',wrapperId)
    if (wrapperId) {
      var checkboxes = $("body").find(`#${wrapperId} input[type="checkbox"]:checked`).length;
      if( checkboxes > 3 ) {
        $(e).prop('checked', false) // Unchecks it
        // Showing the Info Message
        $(".info-message").removeClass("hide");
        setTimeout(function(){
          $(".info-message").addClass("hide");
        }, 3000);
      }
      else if( checkboxes > 2 && checkboxes < 3 ) {
        $(`#${wrapperId} input[type="checkbox"]`).each(function() {
          if ($(this).is(':checked')) {
            console.log("checked");
            $(this).siblings().removeClass("unchecked");
            $(this).siblings().addClass("checked");
          }
          else {
            $(this).prop('disabled', true);
            $(this).siblings().addClass("unchecked");
            $(this).siblings().removeClass("checked");
          }
        })
      }
      else {
        // console.log('else');
        // $(this).siblings().removeClass("checked");
        $("body").find(`#${wrapperId} input[type="checkbox"]`).prop('disabled', false);
        $(".start-subscription-btn").attr("disabled", true)
        $(".anya-starter-kit-check").attr("disabled", true)
      }
    }

    // Handling the start subscription button
    enableDisableStartSubscriptionButton()
    showProductListOnMonthBoxBreastFeed()
    // showProductListOnMonthBoxNonBreastFeed()
    enableDisableStartAnyaSubscriptionButton()

  }
function showProductListOnMonthBoxBreastFeed(e) {
  $("body").find(`.subscription-month-box-breastfeed-ul`).html("");
  var assignCheckedProducts = "";
  if ('#breastFeedingMonth1Products') {
      $("body").find(`#breastFeedingMonth1Products input[type="checkbox"]:checked`).each(function (index) {
        var checkedProductTitle = $(this).attr('data-id');
        var productHandle = $(this).data('product-handle');
        var checkedProductHighlight = $(this).attr('data-highlight');
        $("body").find(`.subscription-month-box-breastfeed-ul`).html("");
        assignCheckedProducts += `<li>Product ${index+1}: <a target="_blank" href="/products/${productHandle}">${checkedProductTitle}</a>`;
        if(checkedProductHighlight != ""){
          assignCheckedProducts += `<div class='product-short-detail'>${checkedProductHighlight}</div>`;
        }
		assignCheckedProducts += `</li>`;
      $("body").find(`.subscription-month-box-breastfeed-ul`).append(assignCheckedProducts);
    });
  }
}

function showProductListOnMonthBoxNonBreastFeed(e) {
  $("body").find(`.subscription-month-box-nonbreastfeed-ul`).html("");
  var assignCheckedProducts = "";
  if ('#nonBreastFeedingMonth1Products') {
      $("body").find(`#nonBreastFeedingMonth1Products input[type="checkbox"]:checked`).each(function (index) {
        var checkedProductTitle = $(this).attr('data-id');
        var productHandle = $(this).data('product-handle');
         var checkedProductHighlight = $(this).attr('data-highlight');
        $("body").find(`.subscription-month-box-nonbreastfeed-ul`).html("");
        assignCheckedProducts += `<li>Product ${index+1}: <a target="_blank" href="/products/${productHandle}">${checkedProductTitle}</a>`;
        if(checkedProductHighlight != ""){
          assignCheckedProducts += `<div class='product-short-detail'>${checkedProductHighlight}</div>`;
        }
		assignCheckedProducts += `</li>`;
      $("body").find(`.subscription-month-box-nonbreastfeed-ul`).append(assignCheckedProducts);
    });
  }
}

  /**
  * If user checked the breastfeeding checkbox then counting the number of checkbox clicked
  * and enabling/disabling the start subscription button
  **/
function enableDisableStartSubscriptionButton() {

  var breastFeedingCheckboxLength = $("body")
      .find(`#breastFeedingMonth1Products input[type="checkbox"]:checked`).length;

  if (breastFeedingCheckboxLength == 3) {
    $(".start-subscription-btn").attr("disabled", false);
  } else {
    $(".start-subscription-btn").attr("disabled", true);
  }

}

  /**
  * By default showing first three items as clicked
  **/
  // window.onload = CheckUncheckAll();
  function CheckUncheckAll() {
    var appendData = "";
    $("body").find('#nonBreastFeedingMonth1Products input[type="checkbox"]').each(function( index ) {
      if (index < 3) {
        $(this).prop("checked", true)
      }
    })

    $("body").find('#breastFeedingMonth1Products input[type="checkbox"]').each(function( index ) {
      if (index < 3) {
        // $(this).trigger("click")
        $(this).prop("checked", true)
       }
    })

    // Handling the start subscription button
    enableDisableStartSubscriptionButton()
    showProductsOnMonthBoxBreastFeed()
    showProductsOnMonthBoxNonBreastFeed()

    // $('#nonBreastFeedingMonth1Products .product-as-card .am-kh_').attr('checked', true).attr('disabled', false);
    // //$(document).on("each", ".product-as-card .am-kh_", function(){
    // $("#nonBreastFeedingMonth1Products .product-as-card .am-kh_").each(function() {
    //   if ($(this).is(':checked')) {
    //     $(this).siblings().removeClass("unchecked");
    //     $(this).siblings().addClass('checked');
    //   }
    //   else {
    //
    //   }
    // });
    //
    // $(document).on("click", "#nonBreastFeedingMonth1Products .unchecked", function(){
    //   var checkboxes = $('#nonBreastFeedingMonth1Products .am-kh_:checked').length;
    //   if(checkboxes > 2) {
    //     $(".info-message").removeClass("hide");
    //     setTimeout(function(){
    //       $(".info-message").addClass("hide");
    //     }, 7000);
    //   }
    // });
  };

  /**
  * Check uncheck conditinal code for breastfeeding
  **/
  function CheckUncheckAllBreastFeeding() {
    // $('#breastFeedingMonth1Products .product-as-card .am-kh_').attr('checked', true).attr('disabled', false);
    // //$(document).on("each", ".product-as-card .am-kh_", function(){
    // $("#breastFeedingMonth1Products .product-as-card .am-kh_").each(function() {
    //   if ($(this).is(':checked')) {
    //     $(this).siblings().removeClass("unchecked");
    //     $(this).siblings().addClass('checked');
    //   }
    //   else {
    //
    //   }
    // });
    //
    // $(document).on("click", "#breastFeedingMonth1Products .unchecked", function(){
    //   var checkboxes = $('#breastFeedingMonth1Products .am-kh_:checked').length;
    //   if(checkboxes > 2) {
    //     $(".info-message").removeClass("hide");
    //     setTimeout(function(){
    //       $(".info-message").addClass("hide");
    //     }, 7000);
    //   }
    // });
    //
    // $(document).on("click", "#breastFeedingMonth1Products .am-kh_", function(){
    //   var checkboxes = $('#breastFeedingMonth1Products .am-kh_:checked').length;
    //   if(checkboxes > 2) {
    //     $("#breastFeedingMonth1Products .product-as-card .am-kh_").each(function() {
    //       if ($(this).is(':checked')) {
    //         $(this).siblings().removeClass("unchecked");
    //         $(this).siblings().addClass("checked");
    //       }
    //       else {
    //         $(this).prop('disabled', true);
    //         $(this).siblings().addClass("unchecked");
    //         $(this).siblings().removeClass("checked");
    //       }
    //     });
    //   }
    //   else {
    //     $(this).siblings().removeClass("checked");
    //     $('#breastFeedingMonth1Products .product-as-card .am-kh_').prop('disabled', false);
    //   }
    // })
  };


  /////// jquery Validation//////////////////

  $(document).ready(function() {
    $("#address_form_new, #create_customer").validate();
  });

  /////// Phone number Validation//////////////////

  setTimeout(function(){
    $(document).ready(function() {
      $('#AddressPhoneNew').blur(function(e) {
        if (validatePhone('AddressPhoneNew')) {
          $('#spnPhoneStatus').html('');
          $('#spnPhoneStatus').css('color', 'green');
          $('.filled_form').prop('type', 'submit');
        }

          else {
        if(!$('#AddressPhoneNew').val()){
           $('#spnPhoneStatus').html("");
        $('.filled_form').prop('type', 'button');
        }

          else {
          $('#spnPhoneStatus').html('Invalid Number');
          $('.filled_form').prop('type', 'button');
          $('#spnPhoneStatus').css('color', 'red');
        }
      }



      });
    });

    function validatePhone(AddressPhoneNew) {
      var a = document.getElementById(AddressPhoneNew).value;
      var filter = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
      //var filter = [0-9]{10,12};
      if (filter.test(a)) {
        return true;
      }
      else {
        return false;
      }
    }

  }, 3000);




// $(document).ready(function(){
//     $('input[type="radio"]').click(function(){
//       console.log("here======>")
//         var inputValue = $(this).attr("data");
//         var targetBox = $("." + inputValue);
//         $(".shipping-cls").not(targetBox).hide();
//         $(targetBox).show();
//           if(inputValue == "All-in-one"){
//             $("#gift-note").show();
//             $("#button-first").show();
//             $("#button-first1").hide();
//             $("input[name='_recipiant_first_name'], input[name='_recipiant_last_name']").prop('required',true);
//           }
//           else{
//             $("#gift-note").hide();
//             $("#button-first").hide();
//              $("#button-first1").show();
//             $("input[name='_recipiant_first_name'], input[name='_recipiant_last_name']").prop('required',false);
//           }
//     });
// });

$(document).ready(function(){
$(".show_item").click(function(){
  $(".show_item").addClass("edit-button-is-clicked");

  // Always show breastfeeding products
  $(".brest-feed").show();
  $(".nonbrest-feed").hide();

  $("#breastFeedingMonth1ProductsPagination").show();
  $("#nonBreastFeedingMonth1ProductsPagination").hide();

  $(".dynamicProductsWrapperRedeemBreastfeed")
      .removeClass("hide")
      .addClass("open");

});
});



// $(function () {
//   $("#breastfeeding-checkbox").click(function () {
//     if ($('#see-our-recommendation').hasClass("button-is-clicked") && $(this).is(":checked")) {
//       $("#subscription-month-box-breastfeed").removeClass("hide");
//       if ($("body").find('#Breastfeeding-Edit-your-box').hasClass("edit-button-is-clicked")) {
//         $(".dynamicProductsWrapperRedeemBreastfeed").removeClass("hide");
//         $(".dynamicProductsWrapperRedeemNonBreastfeed").addClass("hide");
//       }
//       $("#subscription-month-box-nonbreastfeed").addClass("hide");
//       $("#monthly-package-b-redeem").removeClass("hide");
//       $("#monthly-package-nonbrestfeed-redeem").addClass("hide");
//       $(".brest-feed").show();
//       $(".nonbrest-feed").hide();
//       $("#breastFeedingMonth1ProductsPagination").show();
//       $("#nonBreastFeedingMonth1ProductsPagination").hide();
//        $(".collection-breastfeed").show();
//       $(".collection-nonbreastfeed").hide();
//     }
//     if ($('#see-our-recommendation').hasClass("button-is-clicked") && !$(this).is(":checked")) {
//       $("#subscription-month-box-breastfeed").addClass("hide");
//       if ($("body").find('#NonBreastfeeding-Edit-your-box').hasClass("edit-button-is-clicked")) {
//       	$(".dynamicProductsWrapperRedeemBreastfeed").addClass("hide");
//       	$(".dynamicProductsWrapperRedeemNonBreastfeed").removeClass("hide");
//       }
//       $("#subscription-month-box-nonbreastfeed").removeClass("hide");
//       $("#monthly-package-b-redeem").addClass("hide");
//       $("#monthly-package-nonbrestfeed-redeem").removeClass("hide");
//       $(".brest-feed").hide();
//       $(".nonbrest-feed").show();
//       $("#breastFeedingMonth1ProductsPagination").hide();
//       $("#nonBreastFeedingMonth1ProductsPagination").show();
//       $(".collection-breastfeed").hide();
// //       if ($("body").find('#Non-Edit-your-box').hasClass("edit-button-is-clicked")) {
//       $(".collection-nonbreastfeed").show();
// //       }
//     }

//     // Handling the start subscription button
//     enableDisableStartSubscriptionButton()
//   });
// });

$(function () {
  $("#csection-checkbox").click(function () {
    enableDisableStartSubscriptionButton()
  });
});

  $(function() {
   $('#dueDateChangeType').hide();
    $('#paragraphSpaceOPtionRedeem').change(function(){
        if($('#paragraphSpaceOPtionRedeem').val() == 'Pregnant') {
            $('#dueDateChangeType').hide();
            $('#dueDateType').show();
        } else {
            $('#dueDateChangeType').show();
           $('#dueDateType').hide();
        }
    });
});

// function openMonthBox() {
//   if ( $("#breastfeeding-checkbox").is(":checked") ) {
//     $(".collection-nonbreastfeed").hide();
//     $(".collection-breastfeed").show();

//     $("#subscription-month-box-breastfeed").removeClass("hide").addClass("open");
//     $("#monthly-package-b-redeem").removeClass("hide");
//     //  document.getElementById('see-our-recommendation').setAttribute("disabled","disabled");
//     $("#see-our-recommendation").addClass("button-is-clicked");
//   }
//   else{
//     $(".collection-nonbreastfeed").show();
//     $(".collection-breastfeed").hide();
//     $("#subscription-month-box-nonbreastfeed").removeClass("hide").addClass("open");
//     $("#monthly-package-nonbrestfeed-redeem").removeClass("hide");
//     //  document.getElementById('see-our-recommendation').setAttribute("disabled","disabled");
//      $("#see-our-recommendation").addClass("button-is-clicked");
//   }
// }
function openMonthBox() {

  // Always show breastfeeding collections
  $(".collection-nonbreastfeed").hide();
  $(".collection-breastfeed").show();

  // Open breastfeeding month box
  $("#subscription-month-box-nonbreastfeed").addClass("hide");
  $("#subscription-month-box-breastfeed").removeClass("hide").addClass("open");

  // Show breastfeeding redeem section
  $("#monthly-package-nonbrestfeed-redeem").addClass("hide");
  $("#monthly-package-b-redeem").removeClass("hide");

  $("#see-our-recommendation").addClass("button-is-clicked");

}

$(document).ready(function(){
    // $("#breastfeeding-checkbox").prop("checked", true);
  openMonthBox();
    // check first 3 breastfeeding products
  $('#breastFeedingMonth1Products input[type="checkbox"]:lt(3)').prop('checked', true);

  // render product titles
  showProductListOnMonthBoxBreastFeed();
    if($(".redeem-button").length > 0) {
      var flagged = false;
      // $(".redeem-button").attr("disabled", "disabled");
      setTimeout(() => {
        if(localStorage.getItem('breastfeedingCheckbox') == 'true') {
          $('#breastfeeding-checkbox').prop('checked', true);
        }
        if(localStorage.getItem('redeemGiftDeliveryDate') && localStorage.getItem('redeemGiftDueDate') ) {
            var due_date = localStorage.getItem('redeemGiftDueDate');
            var delivery_date = localStorage.getItem('redeemGiftDeliveryDate');
            if(due_date != '' && delivery_date != '' ) {
              flagged = true;
            }
        }
        if(flagged) {
          $(".redeem-button").removeAttr("disabled");
          openMonthBox();
          if(localStorage.getItem('RPEdited') == 'true') {
            $('html, body').animate({
               scrollTop: $(`#as-product-step-1`).offset().top
              }, 800);
              console.log('heref')
            localStorage.removeItem('RPEdited');
          }
        }

      }, 500);
    }
    
  $('#paragraphSpaceOPtion').change(function() {
    $("#Breastfeeding-box-trigger").removeAttr("disabled");
    $("#Non-breastfeeding-box-trigger").removeAttr("disabled");
    $(".start-subscription-btn").attr("disabled", true)
    var selectedOption=$(this).find('option:selected').val();
    var strg = selectedOption.replace(/ +/g, "");
    if(strg == "Pregnant"){
      $('#Pregnant').show();
      $('#due-datepicker-redeem').show();
      $('#AlreadyDelivered').hide();
      $('#due-datepicker-redeem1').hide();
      $('#due-datepicker').val('');
      $("input[name='due_datepicker-already']").val("");
      $("input[name='due_datepicker']").val("");
    }
    if(strg == "AlreadyDelivered"){
      $('#Pregnant').hide();
      $('#due-datepicker-redeem').hide();
      $('#due-datepicker1').val('');
      $('#AlreadyDelivered').show();
      $('#due-datepicker-redeem1').show();
      $("input[name='due_datepicker']").val("");
      $("input[name='due_datepicker-already']").val("");
    }
    var dueDatePicker = document.getElementById("due-datepicker").value;
    var dueDatePicker1 = document.getElementById("due-datepicker1").value;
//     console.log(dueDatePicker, dueDatePicker1)
    localStorage.setItem('redeemGiftDueDate', dueDatePicker + dueDatePicker1);
 });
});

function toggleCtcButton() {
  $('.show-checkout-button').removeClass("hide");
  $('.hide-checkout-button').addClass("hide");

}
function anotherRandomFunction(){
  	$("#Breastfeeding-box-trigger")[0].click();
}



// Header Sticky
$(window).scroll(function () {
  if ($(window).scrollTop() >= 300) {
    $('.is-scrolled-header').addClass('is-scrolled');
    $('.cm-cta-fixed-top').addClass('scrolled');
  }
  else {
    $('.is-scrolled-header').removeClass('is-scrolled');
    $('.cm-cta-fixed-top').removeClass('scrolled');
  }
});
// Header Sticky

  $(document).ready(function() {
  (function() {
    var showChar = 115;
    var ellipsestext = "...";

    $(".truncate .testimonials-card-title").each(function() {
      var content = $(this).html();
      // console.log(content)
      // console.log(content.length)
      if (content.length > showChar) {
        var c = content.substr(0, showChar);
        var h = content;
        var html =
          '<div class="truncate-text" style="display:block">' +
          c +
          '<span class="moreellipses">' + ellipsestext +
          '<a href="" class="moreless more">Read More</a></span></span></div><div class="truncate-text" style="display:none">' +
          h +
          '</span></div>';

        $(this).html(html);
      }
    });

    $(".moreless").click(function() {
      var thisEl = $(this);
      var cT = thisEl.closest(".truncate-text");
      var tX = ".truncate-text";

      if (thisEl.hasClass("less")) {
        cT.prev(tX).toggle();
        cT.slideToggle();
      } else {
        cT.toggle();
        cT.next(tX).fadeToggle();
      }
      return false;
    });
  })();

});

// $(function(){
// if(window.location.hash){
//   $('html,body').animate({
//         scrollTop:$(window.location.hash).offset().top + 'px'
//         },2500,'swing');
//     }
// });

(function () {

  var quotes = $(".top-messaging__content p");
  var quoteIndex = -1;

  function showNextQuote() {
    ++quoteIndex;
    quotes.eq(quoteIndex % quotes.length < 1)
      .fadeIn(1000)
      .delay(1000)
      .fadeOut(1000, showNextQuote);
  }

  showNextQuote();

})();

function enableDisableStartAnyaSubscriptionButton() {
  var breastFeedingCheckboxLength = $("body").find(`#breastFeedingMonth1Products input[type="checkbox"]:checked`).length;
  if( breastFeedingCheckboxLength == 3 ) {
    $(".anya-starter-kit-check").attr("disabled", false)
  }
  else {
    $(".anya-starter-kit-check").attr("disabled", true)
  }
}

$(document).ready(function(){
  $('input[name="userstatus"]').change(function() {
    $("#Breastfeeding-box-trigger").removeAttr("disabled");
    $("#Non-breastfeeding-box-trigger").removeAttr("disabled");
    $(".start-subscription-btn").attr("disabled", true)
    var selectedOption = $(this).val();
    localStorage.setItem('currentuserstatus', selectedOption);
    var strg = selectedOption.replace(/ +/g, "");
    if(strg == "Pregnant"){
      $('#Pregnant').show();
      $('#due-datepicker-redeem').show();
      $('#AlreadyDelivered').hide();
      $('#due-datepicker-redeem1').hide();
    }
    if(strg == "AlreadyDelivered"){
      $('#Pregnant').hide();
      $('#due-datepicker-redeem').hide();
      $('#due-datepicker1').val('');
      $('#AlreadyDelivered').show();
      $('#due-datepicker-redeem1').show();
	}
    var dueDatePicker = document.getElementById("due-datepicker").value;
    var dueDatePicker1 = document.getElementById("due-datepicker1").value;
//     console.log(dueDatePicker, dueDatePicker1)
    localStorage.setItem('redeemGiftDueDate', dueDatePicker + dueDatePicker1);
 });
});

var radios = document.getElementsByName("userstatus");
var val = localStorage.getItem('currentuserstatus');
for(var i=0;i<radios.length;i++){
  if(radios[i].value == val){
      radios[i].checked = true;
  }
}

function showProductsOnMonthBoxBreastFeed(e) {
  $("body").find(`.js-b-customized-plan-kit-products`).html("");
  var assignCheckedProducts = "";
  if ('#breastFeedingMonth1Products') {
      $("body").find(`#breastFeedingMonth1Products input[type="checkbox"]:checked`).each(function (index) {
         var productIndex = `Product ${index+1}`;
         var productHandle = $(this).data('product-handle'); 
         var checkedProductTitle = $(this).closest('.product-as-content').find('.js-product-title').html();
         var checkedProductImage = $(this).closest('.product-as-content').parent().find(`.product-as-item-thumb img`).attr('src');
         var checkedProductDose = $(this).closest('.product-as-content').find('.js-product-dose').html();
         var checkedProductBenefits = $(this).closest('.product-as-content').find('.js-product-benefits').html();
//         console.log(productIndex, checkedProductImage, checkedProductTitle, checkedProductDose, checkedProductBenefits)
        $("body").find(`.js-b-customized-plan-kit-products`).html("");
        assignCheckedProducts +=
         `<div class="customized-plan-kit-product-item">
            <div class="customized-plan-kit-product-count">
				${index+1} 
            </div>
            <a class="customized-plan-kit-product-block" href="/products/${productHandle}">
			<div class="customized-plan-kit-product-card">
              <div class="customized-plan-kit-product-thumb">
                <img src="${checkedProductImage}" alt="" loading="lazy" class="Image--lazyLoad">
                <div class="thumb-title">
                  ${productIndex}
                </div>
              </div>
              <div class="customized-plan-kit-product-info">
                <h4 class="customized-plan-kit-product-subtitle">${checkedProductDose}</h4>
                <h2 class="customized-plan-kit-product-title">${checkedProductTitle}</h2>
                <div class="customized-plan-kit-product-desc">${checkedProductBenefits}</div>
              </div>
            </div>
		  </a>
          </div>`;
    });
    var length = $("body").find(`#breastFeedingMonth1Products input[type="checkbox"]:checked`).length;
    var productCardBlank = `<div class="customized-plan-kit-product-card-blank">
                <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.13616 17.0767L0.136159 21.3497L17.0764 21.3497L17.0764 38.2899H21.3494L21.3494 21.3497L38.2896 21.3497L38.2896 17.0767L21.3494 17.0767L21.3494 0.136458H17.0764L17.0764 17.0767L0.13616 17.0767Z" fill="#D46F48"/>
                </svg>
              </div>`;
    if(length === 0){
    assignCheckedProducts+= 
            `<div class="customized-plan-kit-product-item">
			  <div class="customized-plan-kit-product-count">${length+1}</div>
				${productCardBlank}
			 </div>
		     <div class="customized-plan-kit-product-item">
              <div class="customized-plan-kit-product-count">${length+2}</div>
               ${productCardBlank}
             </div>
			 <div class="customized-plan-kit-product-item">
              <div class="customized-plan-kit-product-count">${length+3}</div>
               ${productCardBlank}
             </div>`;
    }
    if(length === 1){
    assignCheckedProducts+= 
            `<div class="customized-plan-kit-product-item">
              <div class="customized-plan-kit-product-count">${length+1}</div>
               ${productCardBlank}
             </div>
			 <div class="customized-plan-kit-product-item">
              <div class="customized-plan-kit-product-count">${length+2}</div>
               ${productCardBlank}
             </div>`;
    }
    if(length === 2){
    assignCheckedProducts+= 
            `<div class="customized-plan-kit-product-item">
              <div class="customized-plan-kit-product-count">${length+1}</div>
               ${productCardBlank}
             </div>`;
    }
    $("body").find(`.js-b-customized-plan-kit-products`).append(assignCheckedProducts);
  }
}
function showProductsOnMonthBoxNonBreastFeed(e) {
  $("body").find(`.js-n-customized-plan-kit-products`).html("");
  var assignCheckedProducts = "";
  if ('#nonBreastFeedingMonth1Products') {
      $("body").find(`#nonBreastFeedingMonth1Products input[type="checkbox"]:checked`).each(function (index) {
         var productIndex = `Product ${index+1}`;
         var productHandle = $(this).data('product-handle'); 
         var checkedProductTitle = $(this).closest('.product-as-content').find('.js-product-title').html();
         var checkedProductImage = $(this).closest('.product-as-content').parent().find(`.product-as-item-thumb img`).attr('src');
         var checkedProductDose = $(this).closest('.product-as-content').find('.js-product-dose').html();
         var checkedProductBenefits = $(this).closest('.product-as-content').find('.js-product-benefits').html();
//         console.log(productIndex, checkedProductImage, checkedProductTitle, checkedProductDose, checkedProductBenefits)
        $("body").find(`.js-n-customized-plan-kit-products`).html("");
        assignCheckedProducts +=
         `<div class="customized-plan-kit-product-item">
            <div class="customized-plan-kit-product-count">
				${index+1} 
            </div>
            <a class="customized-plan-kit-product-block" href="/products/${productHandle}">
			 <div class="customized-plan-kit-product-card">
              <div class="customized-plan-kit-product-thumb">
                <img src="${checkedProductImage}" alt="" loading="lazy" class="Image--lazyLoad">
                <div class="thumb-title">
                  ${productIndex}
                </div>
              </div>
              <div class="customized-plan-kit-product-info">
                <h4 class="customized-plan-kit-product-subtitle">${checkedProductDose}</h4>
                <h2 class="customized-plan-kit-product-title">${checkedProductTitle}</h2>
                <div class="customized-plan-kit-product-desc">${checkedProductBenefits}</div>
              </div>
            </div>
		   </a>
          </div>`;
    });
    var length = $("body").find(`#nonBreastFeedingMonth1Products input[type="checkbox"]:checked`).length;
    var productCardBlank = `<div class="customized-plan-kit-product-card-blank">
                <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.13616 17.0767L0.136159 21.3497L17.0764 21.3497L17.0764 38.2899H21.3494L21.3494 21.3497L38.2896 21.3497L38.2896 17.0767L21.3494 17.0767L21.3494 0.136458H17.0764L17.0764 17.0767L0.13616 17.0767Z" fill="#D46F48"/>
                </svg>
              </div>`;
    if(length === 0){
    assignCheckedProducts+= 
            `<div class="customized-plan-kit-product-item">
			  <div class="customized-plan-kit-product-count">${length+1}</div>
				${productCardBlank}
			 </div>
		     <div class="customized-plan-kit-product-item">
              <div class="customized-plan-kit-product-count">${length+2}</div>
               ${productCardBlank}
             </div>
			 <div class="customized-plan-kit-product-item">
              <div class="customized-plan-kit-product-count">${length+3}</div>
               ${productCardBlank}
             </div>`;
    }
    if(length === 1){
    assignCheckedProducts+= 
            `<div class="customized-plan-kit-product-item">
              <div class="customized-plan-kit-product-count">${length+1}</div>
               ${productCardBlank}
             </div>
			 <div class="customized-plan-kit-product-item">
              <div class="customized-plan-kit-product-count">${length+2}</div>
               ${productCardBlank}
             </div>`;
    }
    if(length === 2){
    assignCheckedProducts+= 
            `<div class="customized-plan-kit-product-item">
              <div class="customized-plan-kit-product-count">${length+1}</div>
               ${productCardBlank}
             </div>`;
    }
    $("body").find(`.js-n-customized-plan-kit-products`).append(assignCheckedProducts);
  }
}

$(document).on('click', '.js-add-down', function(e){
  var variantId = $(this).attr("data-attr")
  e.preventDefault();
  var input = $(this).closest(".js-quantity").find(".js-qty");
  var value = input.val();
  if (value > 0) {
    value--;
  }
  input.val(value);
  var value = input.val();
  $(this).closest(".js-quantity").find(".js-qty").attr("value", `${value}`);
});
$(document).on('click', '.js-add-up', function(e){
  var variantId = $(this).attr("data-attr")
  e.preventDefault();
  var input = $(this).closest(".js-quantity").find(".js-qty");
  var value = input.val();
  value++;
  input.val(value);
  var value = input.val();
  $(this).closest(".js-quantity").find(".js-qty").attr("value", `${value}`);
});
$(document).on('click', '.js-quantity-button', function(e){
  var val = 0
  $(`.js-quantity-manager .js-qty`).each(function(i){
    var $this = $(this);
    val += parseInt($this.val());
  });
  $(".starterkit-checkout-btn").removeAttr("disabled");
  $(".starterkit-checkout-btn").html(`Checkout $70 - (${val}/3)`);
  if(val >=3){
    $('#anya-starter-kit-modal').find(`.starter__kit__modal--footer .js-add-to-box`).attr("disabled", "disabled");
    $('.js-add-up, .js-qty').attr("disabled", "disabled");
    $(".starterkit-checkout-btn").removeAttr("disabled");
  }else{
    $('#anya-starter-kit-modal').find(`.starter__kit__modal--footer .js-add-to-box`).removeAttr("disabled");
    $(`.js-quantity-manager`).each(function(){
      var inventoryQty = $(this).attr('productInventory')
      // console.log(inventoryQty)
      if(inventoryQty <= 0){
        $(this).find('.js-add-up').attr("disabled", "disabled");
        $(this).find('.js-qty').attr("disabled", "disabled");
      }else{
        $(this).find('.js-add-up').removeAttr("disabled");
        $(this).find('.js-qty').removeAttr("disabled");
      }
    })
    $(".starterkit-checkout-btn").attr("disabled", "disabled");
  }
});
$(document).ready(function(){
  $('input[name="userselection"]').change(function() {
    var selectedOption = $(this).val();
    if(selectedOption == "one-time-purchase"){
      $('.purchasing__options #one-time-purchase-button').show();
      $('#anya-recovery-plan-button').hide();
	}
    if(selectedOption == "anya-recovery-plan"){
      $('.purchasing__options #one-time-purchase-button').hide();
      $('#anya-recovery-plan-button').show();
    }
    if(selectedOption == "subscribe-product"){
      $('.purchasing__options #one-time-purchase-button').show();
      $('#anya-recovery-plan-button').hide();
    }
 });
});

$(document).ready(
  function(){
    $("#subscription-plan-learn-more").click(function () {
      var text = $("#subscription-plan-learn-more").html();
      var strg = text.replace(/ +/g, "");
      if(strg == "LearnMore"){
        $("#subscription-plan-learn-more").html('Read Less');
      }
      else{
      	$("#subscription-plan-learn-more").html('Learn More');
      }
      $("#subscription-plan-learn-more-text").slideToggle();
    });
});
function facebookEvent() {
  console.log("facebookEvent")
  fbq('track', 'Recovery Form Complete');
}


// Click on see review then redirect to home page and scroll down
// var count = 0
// $(document).ready(function () {
//     var searchParams = new URLSearchParams(window.location.search)
//     var param = searchParams.get('action')
//     if (param === 'scrolltoreviews') {
//       $('html,body').animate({
//         scrollTop:$("#scroll-target-id-okendo").offset().top - 100
//         },1500,'swing');
//     }
// });